// is this really better than normal case? Have to-remap in components for TS
export enum TrainingGrantsMutations {
  RESET = "RESET",
  SET_TRAINING_GRANT = "SET_TRAINING_GRANT",
  SET_TRAINING_GRANTS = "SET_TRAINING_GRANTS",
}
